import PropTypes from "prop-types";
import { Button, Space } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";

import { useCustomToolStore } from "../../../store/custom-tool-store";
import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../../store/session-store";
import { useAlertStore } from "../../../store/alert-store";
import { useExceptionHandler } from "../../../hooks/useExceptionHandler";
import "./CloneFooter.css";

function CloneFooter({ toolName, setOpenCloneModal }) {
  const { isPublicSource } = useCustomToolStore();
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();
  const { id } = useParams();
  const [isCloneLoading, setIsCloneLoading] = useState(false);
  const navigate = useNavigate();

  const handleClone = (isClone) => {
    setIsCloneLoading(true);
    if (isPublicSource) {
      return navigate("/landing");
    }
    const body = {
      tool_id: id,
      tool_name: toolName,
    };
    const requestOptions = {
      method: "POST",
      url: `/api/v1/unstract/${sessionDetails?.orgId}/prompt-studio/clone/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
        "Content-Type": "application/json",
      },
      data: body,
    };

    axiosPrivate(requestOptions)
      .then((response) => {
        const clonedTool = response?.data?.tool_id;
        window.open(
          `${window.location.origin}/${sessionDetails?.orgName}/tools/${clonedTool}`,
          "_blank",
          "noreferrer"
        );
        setAlertDetails({
          type: "success",
          content: "Project cloned sucessfully",
        });
        setOpenCloneModal(false);
      })
      .catch((err) => {
        setAlertDetails(handleException(err, "Failed to clone project"));
      })
      .finally(() => {
        setIsCloneLoading(false);
      });
  };

  return (
    <div className="clone-button">
      <Space>
        <Button onClick={() => setOpenCloneModal(false)}>Cancel</Button>
        <Button type="primary" onClick={handleClone} loading={isCloneLoading}>
          {isPublicSource ? "Sign up to Clone" : "Clone"}
        </Button>
      </Space>
    </div>
  );
}

CloneFooter.propTypes = {
  setOpenCloneModal: PropTypes.func.isRequired,
  toolName: PropTypes.string.isRequired,
};
export { CloneFooter };
